<template>
    <div class="completed-sorting">
        <h2 class="completed-sorting__title" v-html="title"></h2>
        <EmptyStateNotification :content="emptyState.content" :hint="emptyState.hint" v-if="!hasAnyCourses">
            <TotemButton
                @click="emptyStateButtonHandler"
                color="primary"
                :label="emptyState.button"
                icon="arrow-right"
                iconPosition="right"
            />
        </EmptyStateNotification>
        <div class="completed-sorting__container">
            <slot></slot>
            <TotemSelect
                v-if="hasAnyCourses"
                :options="orders"
                :placeholder="$t('CollectionFilter.from_new_to_old')"
                type="sorting"
                @input="selectSorter"
                :reduce="option => option.value"
                :value="sorting"
                showSelectedOption
                :clearable="false"
                :width="290"
                :class="{ 'totem-dk': $totemLang === 'dk' }"
            />
        </div>
    </div>
</template>

<script>
    import userHubCompletedCoursesSorting from 'components/shared/mixins/sorting/userHubCompletedCoursesSorting'
    import EmptyStateNotification from 'components/user/shared/EmptyStateNotification'

    export default {
        components: { EmptyStateNotification },
        mixins: [
            userHubCompletedCoursesSorting
        ],
        props: {
            completedCourses: {
                type: Array,
                default: () => []
            },
            title: String,
            type: String
        },
        inject: {
            activateTab: {
                from: 'activateTab',
                default: null
            },
            recommendedTabId: {
                from: 'recommendedTabId',
                default: ''
            }
        },
        computed: {
            hasAnyCourses () {
                return this.completedCourses.length > 0
            },
            emptyState () {
                if (this.type === 'courses') {
                    return {
                        content: this.$t('CompletedCoursesTab.no_courses'),
                        hint: this.$t('CompletedCoursesTab.no_courses_hint'),
                        button: this.$t('General.see_our_recommendations_button_label'),
                    }
                } else {
                    return {
                        content: this.$t('CompletedCoursesTab.no_learning_paths'),
                        hint: this.$t('CompletedCoursesTab.no_learning_paths_hint'),
                        button: this.$t('LandingPage.explore_learning_paths')
                    }
                }
            }
        },
        methods: {
            emptyStateButtonHandler () {
                if (this.type === 'courses') {
                    this.activateTab ? this.activateTab(this.recommendedTabId) : this.$router.push({ name: 'home-courses' })
                } else {
                    this.$router.push({ name: 'all-packages-learning-paths' })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.completed-sorting {

    &__title {
        font-family: PlusJakartaSans-Medium, sans-serif;
        font-size: 2.2rem;
        margin: 0 0 32px;
    }

    &__description {
        display: block;
        max-width: 600px;
    }

    &__uncompleted-info {
        position: relative;
        top: 2px;
    }

    &__container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 30px;

        [class*="desktop"] & {
            align-items: center;
        }

        [class*="mobile_sm"] & {
            flex-direction: column;
            gap: 15px;
            margin-bottom: 15px;
        }
    }
    .totem-dk {
        margin-left: auto;

        [class*="desktop"] & {
            top: -85px;
        }
    }
}
</style>
